function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import { KZUIComponent } from '@kuaizhan/kui';
import { Link } from 'react-router-dom';
import './style.less';

var SideNavSection = function SideNavSection(_ref) {
  var items = _ref.items,
      title = _ref.title,
      noDivider = _ref.noDivider,
      cur = _ref.cur;
  return /*#__PURE__*/React.createElement("section", {
    className: "side-nav-section"
  }, noDivider ? null : /*#__PURE__*/React.createElement("div", {
    className: "side-section-divider"
  }), /*#__PURE__*/React.createElement("h1", null, title), /*#__PURE__*/React.createElement("nav", null, items.map(function (item, key) {
    if (item.linkType === 'Link') {
      return /*#__PURE__*/React.createElement(Link, {
        key: "".concat(key),
        className: item.cur || item.name === cur ? 'cur' : '',
        to: item.href
      }, item.text);
    }

    return /*#__PURE__*/React.createElement("a", {
      key: "".concat(key),
      className: item.cur || item.name === cur ? 'cur' : '',
      href: item.href
    }, item.text);
  })));
};

SideNavSection.defaultProps = {
  noDivider: false,
  cur: ''
};
SideNavSection.propTypes = {
  noDivider: PropTypes.bool,
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  cur: PropTypes.string
};

var SideNav = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(SideNav, _KZUIComponent);

  var _super = _createSuper(SideNav);

  function SideNav() {
    _classCallCheck(this, SideNav);

    return _super.apply(this, arguments);
  }

  _createClass(SideNav, [{
    key: "render",
    value: function render() {
      var className = this.classname('side-navigation');
      var _this$props = this.props,
          headerContent = _this$props.headerContent,
          footerContent = _this$props.footerContent,
          sections = _this$props.sections,
          cur = _this$props.cur;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.storeRef('navContainer'),
        className: "side-container"
      }, /*#__PURE__*/React.createElement("header", {
        className: "side-header"
      }, headerContent), sections.map(function (section, key) {
        return /*#__PURE__*/React.createElement(SideNavSection, {
          key: "".concat(key),
          title: section.title,
          items: section.items,
          noDivider: !headerContent,
          cur: cur
        });
      }), /*#__PURE__*/React.createElement("footer", {
        className: "side-footer"
      }, footerContent)));
    }
  }]);

  return SideNav;
}(KZUIComponent);

SideNav.propTypes = {
  headerContent: PropTypes.node,
  sections: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.any)
  })),
  footerContent: PropTypes.node,
  cur: PropTypes.string
};
SideNav.defaultProps = {
  headerContent: null,
  sections: [],
  footerContent: null,
  cur: ''
};
export default SideNav;